/**
 * A plain in-memory {@link CalculationContext} backed by a Map.
 *
 * Useful wherever there is no FormGroup: Node/bulkedit batch calculations, unit tests, and
 * cross-package contract fixtures. `emitEvent` is accepted for interface parity but has no effect
 * (there are no listeners to notify here).
 */
export class MemoryCalculationContext {
  store = new Map();
  constructor(initial) {
    if (initial) {
      for (const [key, value] of Object.entries(initial)) {
        this.store.set(key, value);
      }
    }
  }
  get(key) {
    return this.store.get(key);
  }
  set(key, value, _opts) {
    this.store.set(key, value);
  }
  has(key) {
    return this.store.has(key);
  }
  /** Snapshot of all currently-set fields. */
  toObject() {
    return Object.fromEntries(this.store);
  }
}
